import React from 'react';

// styles
import css from './typingMessage.sss';


export const Typing = () => {
    return (
        <div className={css.root} data-qaid='message_block'>
            <span className={css.message}>
                <span data-qaid='msg_text' className={css.dots}>
                    <span className={css.dot} />
                    <span className={css.dot} />
                    <span className={css.dot} />
                </span>
            </span>
        </div>
    );
};
